module.exports = __webpack_public_path__ + "img/奖章1级@3x.9665fa93.png";